module.exports = __webpack_public_path__ + "KaTeX_Fraktur-Bold.84fca0ee.ttf";